import { render } from "./FacultyList.vue?vue&type=template&id=4a9e760a"
import script from "./FacultyList.vue?vue&type=script&lang=js"
export * from "./FacultyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__